// extracted by mini-css-extract-plugin
export default {"bucketButton":"ColorBucket_bucketButton__6EbQZ","bucketImage":"ColorBucket_bucketImage__dU-Ui"};